import { Grid } from "@mui/material"

export const LineComponent = ({
    expansive = true,
    color,
    height,
    margin,
    usedInModal
}: {
    expansive?: boolean,
    color?: string,
    height?: string,
    margin?: string,
    usedInModal?: boolean
}) => {
    return (
        <Grid
            sx={{
                width: expansive ? `calc(100% + ${usedInModal ? 1.5 : 5}rem)` : usedInModal ? "95%" : "100%",
                height: height ? height : "2px",
                backgroundColor: color ? color : "#DDDFFF",
                margin: margin ? margin : '3rem 0rem',
                ml: expansive ? `-${usedInModal ? .75 : 2.5}rem` : usedInModal ? 1 : 0,
                ... (usedInModal && {
                    opacity: 0.5
                }) 
            }}
        />
    )
}